import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { updatePoints } from '../../slices/authSlice';
import { useNavigate } from 'react-router-dom';

const PointHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);
  
  const [payments, setPayments] = useState([]);
  const [pointLogs, setPointLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('LOGS'); // 'LOGS' or 'PAYMENTS'

  // 🚩 [추가] 결제 동의 모달 관련 상태
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        // 병렬 요청으로 속도 최적화
        const [logsRes, payRes] = await Promise.all([
          axios.get('https://the-pivot-logical-battleground.onrender.com/api/payments/logs', config),
          axios.get('https://the-pivot-logical-battleground.onrender.com/api/payments/my', config)
        ]);

        setPointLogs(logsRes.data);
        setPayments(payRes.data);
      } catch (err) {
        console.error("데이터 로드 실패:", err);
      }
    };
    fetchData();
  }, []);

  // 🚩 [수정] 1단계: 금액 버튼 클릭 시 모달 오픈
  const openChargeModal = (amount) => {
    setSelectedAmount(amount);
    setIsAgreed(false); // 초기화
    setShowChargeModal(true);
  };

  // 🚩 [추가] 결제 핸들러 함수
  const handleCharge = () => {
    if (!isAgreed) return alert("환불 규정에 동의하셔야 결제가 가능합니다.");
    if (isLoading) return; // 중복 클릭 방지

    setShowChargeModal(false); // 모달 닫기
    setIsLoading(true);

    const { IMP } = window;
    IMP.init("imp82633138"); // 유저님의 식별코드

    IMP.request_pay({
      pg: "html5_inicis.MOI6015132",
      pay_method: "card",
      merchant_uid: `order_${new Date().getTime()}`,
      name: `The Pivot: ${selectedAmount}P 충전`,
      amount: selectedAmount,
      buyer_tel: user?.phoneNumber,
      buyer_nickname: user?.nickname,
      notice_url: "https://the-pivot-logical-battleground.onrender.com/api/payments/webhook",
      custom_data: { userId: user._id },

      m_redirect_url: "https://the-pivot-s.vercel.app/mypage/history"
    
    }, async (rsp) => {
      if (rsp.success) {
        console.log("포트원 결제 성공 데이터:", rsp); 
        console.log("서버로 보낼 imp_uid:", rsp.imp_uid);

        try {
          const token = localStorage.getItem('token');
          const res = await axios.post('https://the-pivot-logical-battleground.onrender.com/api/payments/complete', {
            imp_uid: rsp.imp_uid,
            merchant_uid: rsp.merchant_uid,
            amount: selectedAmount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          if (res.data.success) {
            dispatch(updatePoints({ points: res.data.points })); // 리덕스 동기화
            alert(`보급 완료! 현재 잔액: ${res.data.points.toLocaleString()} P`);
            window.location.reload();
          } else {
            alert(res.data.message);
          }
        } catch (err) {
          console.error("결제 치명적 에러", err)
          alert("결제 완료되었습니다. 마이페이지를 확인해주세요.");
        }
      } else {
        alert(`결제 실패: ${rsp.error_msg}`);
      }
    });
    setIsLoading(false);
  };

  // 🚩 [추가] 환불 핸들러
  const handleCancel = async (imp_uid, amount) => {
    if (!window.confirm(`${amount.toLocaleString()}P 환불을 진행하시겠습니까? (미사용 시에만 가능)`)) return;

    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('https://the-pivot-logical-battleground.onrender.com/api/payments/cancel', {
        imp_uid,
        reason: "유저 단순 변심 (7일 이내)"
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        dispatch(updatePoints({ points: res.data.points }));
        alert("환불이 완료되었습니다.");
        window.location.reload(); // 내역 갱신
      }
    } catch (err) {
      alert(err.response?.data?.message || "환불 처리에 실패했습니다.");
    }
  };
  
  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <button onClick={() => navigate('/mypage')} style={styles.backBtn}>← 뒤로가기</button>
        <h1 style={styles.title}>전투 자금 관리</h1>
      </div>

      {/* 현재 포인트 요약 */}
      <div style={styles.balanceCard}>
        <span>현재 보유 포인트</span>
        <strong style={{ fontSize: '1.5rem', color: '#ffd700' }}>
          {user?.points?.toLocaleString()} P
        </strong>
      </div>

      {/* 충전 버튼 섹션 */}
      <div style={styles.chargeSection}>
        <h3 style={{ marginBottom: '10px', color: '#888' }}>포인트 충전</h3>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {[100, 1000, 3000, 5000, 10000].map(amt => (
            <button key={amt} onClick={() => openChargeModal(amt)} style={styles.chargeBtn}>
              {amt.toLocaleString()}P
            </button>
          ))}
        </div>
      </div>

      {/* 🚩 [추가] 결제 전 동의 모달창 */}
      {showChargeModal && (
        <div style={styles.modalOverlay} onClick={() => setShowChargeModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>보급품 확보 확인</h3>
              <button onClick={() => setShowChargeModal(false)} style={styles.closeBtn}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.chargeSummary}>
                <span>충전 예정 금액:</span>
                <strong style={{color: '#00d4ff'}}>{selectedAmount.toLocaleString()} P</strong>
              </div>
              
              <div style={styles.refundPolicyBox}>
                <h4 style={{marginTop: 0, fontSize: '0.9rem'}}>환불 규정 및 유의사항</h4>
                <p style={styles.policyText}>
                  <strong>1. 모든 환불 처리는 이용자가 결제한 수단과 동일한 수단으로 대금을 환급하는 것을 원칙으로 합니다. 결제 수단 이외의 방법(현금 입금 등)으로는 환불이 불가능합니다.</strong><br/>
                  2. 회원은 포인트 결제 후 7일 이내에, 사용하지 않은 포인트에 한하여 전액 환불을 요청할 수 있습니다.<br/>
                  3. 이미 사용한 포인트는 환불이 불가능합니다.<br/>
                  4. 이벤트나 보상으로 무상 지급받은 포인트는 환불 대상이 아닙니다.<br/>
                  5. 결제 후 7일이 경과한 경우 환불이 불가합니다.<br/>
                  6. MYPAGE의 '포인트 충전 및 사용 내역 관리 - 결제/환불 내역'에서 결제한 내역에 대해 환불 가능합니다.<br/>
                  7. 충전한 포인트의 사용기한은 1년입니다.
                </p>
              </div>

              <div style={styles.agreeRow}>
                <input 
                  type="checkbox" 
                  id="refundAgree" 
                  checked={isAgreed} 
                  onChange={() => setIsAgreed(!isAgreed)} 
                />
                <label htmlFor="refundAgree" style={{fontSize: '0.85rem', cursor:'pointer', color: '#fff'}}>
                  위 환불 규정을 확인했으며 동의합니다. (필수)
                </label>
              </div>

              <button 
                onClick={handleCharge} 
                style={{
                  ...styles.submitChargeBtn,
                  opacity: isAgreed ? 1 : 0.4,
                  cursor: isAgreed ? 'pointer' : 'not-allowed'
                }}
                disabled={!isAgreed}
              >
                결제 진행 (Authorize)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 탭 메뉴 */}
      <div style={styles.tabContainer}>
        <button 
          onClick={() => setActiveTab('LOGS')} 
          style={activeTab === 'LOGS' ? styles.activeTab : styles.tab}
        >
          포인트 사용 장부
        </button>
        <button 
          onClick={() => setActiveTab('PAYMENTS')} 
          style={activeTab === 'PAYMENTS' ? styles.activeTab : styles.tab}
        >
          결제/환불 내역
        </button>
      </div>

      {/* 탭 내용: 포인트 로그 */}
      {activeTab === 'LOGS' && (
        <div style={styles.listContainer}>
          {pointLogs.length === 0 && <p style={{color:'#666', textAlign:'center'}}>기록이 없습니다.</p>}
          {pointLogs.map(log => (
            <div key={log._id} style={{...styles.listItem, borderLeft: log.amount > 0 ? '4px solid #00d4ff' : '4px solid #ff4e50'}}>
              <div>
                <div style={{fontWeight:'bold'}}>{log.description}</div>
                <small style={{color:'#666'}}>
                  {new Date(log.createdAt).toLocaleDateString()}
                  {/* 🚩 [추가] 만료일 정보가 있다면 화면에 표시 */}
                  {log.expiresAt && (
                    <span style={{ color: '#ff9800', marginLeft: '8px' }}>
                      (소멸 예정: {new Date(log.expiresAt).toLocaleDateString()})
                    </span>
                  )}
                </small>
              </div>
              <span style={{color: log.amount > 0 ? '#00d4ff' : '#ff4e50', fontWeight:'bold'}}>
                {log.amount > 0 ? '+' : ''}{log.amount.toLocaleString()} P
              </span>
            </div>
          ))}
        </div>
      )}

      {/* 탭 내용: 결제 내역 */}
      {activeTab === 'PAYMENTS' && (
        <div style={styles.listContainer}>
          {payments.length === 0 && <p style={{color:'#666', textAlign:'center'}}>결제 내역이 없습니다.</p>}
          {payments.map(pay => (
            <div key={pay._id} style={styles.listItem}>
              <div>
                <div style={{fontWeight:'bold'}}>{pay.amount.toLocaleString()} P 충전</div>
                <small style={{color:'#666'}}>{new Date(pay.createdAt).toLocaleDateString()}</small>
              </div>
              {pay.status === 'paid' ? (
                <button onClick={() => handleCancel(pay.imp_uid, pay.amount)} style={styles.refundBtn}>
                  환불하기
                </button>
              ) : (
                <span style={{color:'#ff4e50', fontSize:'0.8rem'}}>환불완료</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { padding: '40px 20px', background: '#0a0a0a', minHeight: '100vh', color: '#fff', maxWidth: '800px', margin: '0 auto' },
  header: { display: 'flex', alignItems: 'center', marginBottom: '30px', gap: '20px' },
  backBtn: { background: 'transparent', border: '1px solid #444', color: '#aaa', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  title: { margin: 0, fontSize: '1.5rem' },
  balanceCard: { background: '#161616', padding: '20px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', border: '1px solid #333' },
  chargeSection: { marginBottom: '40px' },
  chargeBtn: { background: '#222', border: '1px solid #00d4ff', color: '#fff', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' },
  tabContainer: { display: 'flex', borderBottom: '1px solid #333', marginBottom: '20px' },
  tab: { flex: 1, background: 'transparent', border: 'none', color: '#666', padding: '15px', cursor: 'pointer', fontSize: '1rem' },
  activeTab: { flex: 1, background: 'transparent', borderBottom: '2px solid #00d4ff', color: '#00d4ff', padding: '15px', cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold' },
  listContainer: { display: 'flex', flexDirection: 'column', gap: '10px' },
  listItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#161616', padding: '15px', borderRadius: '6px' },
  refundBtn: { background: 'transparent', border: '1px solid #ff4e50', color: '#ff4e50', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' },

  // 🚩 [추가] 모달 스타일
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', 
    backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
  },
  modalContent: {
    backgroundColor: '#121212', border: '1px solid #333', width: '90%', maxWidth: '400px', 
    borderRadius: '4px', display: 'flex', flexDirection: 'column'
  },
  modalHeader: {
    padding: '15px 20px', borderBottom: '1px solid #222', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
  },
  modalTitle: { fontSize: '1.1rem', color: '#00d4ff', margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer' },
  modalBody: { padding: '20px' },
  chargeSummary: { marginBottom: '20px', display: 'flex', justifyContent: 'space-between', fontSize: '1.1rem' },
  refundPolicyBox: { 
    background: '#1a1a1a', padding: '15px', border: '1px solid #333', borderRadius: '4px', marginBottom: '15px' 
  },
  policyText: { fontSize: '0.8rem', color: '#aaa', lineHeight: '1.5', margin: 0 },
  agreeRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' },
  submitChargeBtn: {
    width: '100%', padding: '15px', background: 'transparent', border: '2px solid #00d4ff',
    color: '#00d4ff', fontSize: '1rem', fontWeight: 'bold', transition: 'all 0.3s'
  }
};

export default PointHistory;